import React from 'react';
import { Headings } from '../components';
import { Team , CTA} from '../container';

import './About.css';


const AboutPage = () => {
  return (
    <>
      <div className="about-h" >
        <div className='container'>
          <Headings title="About Us" text="Mc Heritage consulting is a software development company that is sustainably changing the dynamics surrounding businesses by developing innovative digital technology softwares and solutions. We develop bespoke softwares to help businesses meet their unique needs and scale sustainably."/>
        </div>
    </div>
    
    
    
    <div className="container">
      <CTA />
      <Team />
    </div></>
  )
}

export default AboutPage;